import { escapeHtml } from 'helpers/escape-html';

export const getRefereeIntroDescription = ({ form, formParams, estimatedMinutes, t }) => {
  const customIntro = form?.intro_text?.trim();
  if (customIntro) return escapeHtml(customIntro);
  if (!formParams?.companyName) return '';

  return (
    formParams.companyName +
    ' ' +
    t('refereeForm.companyIntro', {
      candidateFirstName: formParams.candidateFirstName,
      estimatedMinutes,
    })
  );
};
